import { render, staticRenderFns } from "./SocialWallReplyForm.vue?vue&type=template&id=6c06bf51&scoped=true"
import script from "./SocialWallReplyForm.vue?vue&type=script&lang=js"
export * from "./SocialWallReplyForm.vue?vue&type=script&lang=js"
import style0 from "./SocialWallReplyForm.vue?vue&type=style&index=0&id=6c06bf51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06bf51",
  null
  
)

export default component.exports